(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs-app"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* The theme's own Add Post button proxies to the forum app's real
     (hidden) CTA so the app opens its inline compose form — textarea +
     Submit — exactly as if its own button were clicked. The href to the
     external forum is only the fallback for when the app rendered no CTA
     (e.g. it hasn't loaded yet). */
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('[data-forum-cta] a.button');
    if (!cta) return;

    var panel = cta.closest('.product-tabs__panel--forum');
    if (!panel) return;

    var appCta = panel.querySelector('[data-forum-app-cta]');
    if (!appCta) return;

    event.preventDefault();
    appCta.click();

    /* In some app states the compose form renders inside the wrapper that
       was hidden along with the button; if that happened, reveal the
       wrapper and keep only the button itself hidden. Re-run the tidy
       pass too — a form appearing now (after the fixed timers are done)
       still needs its white card flattened. */
    setTimeout(function () {
      var wrap = appCta.__forumHiddenNode;
      if (wrap && wrap !== appCta && wrap.querySelector('textarea')) {
        wrap.style.removeProperty('display');
        appCta.style.setProperty('display', 'none', 'important');
      }
      tidyForumPanel(panel);
    }, 100);
  });

  /* The Reviews snippet app block (Judge.me) renders nothing into its panel
     when the product has zero reviews, so show the "No reviews yet" note in
     that case. Judge.me loads asynchronously at an unpredictable time, so
     this runs a small FIXED number of one-time checks rather than a
     MutationObserver — an earlier version used an observer watching the
     panel's subtree, which reacted to every internal change Judge.me's
     widget made and froze the page. These checks are bounded: each one runs
     exactly once and stops, so there is no way for this to loop.

     Content is detected via Judge.me's own star markup (`.jdgm-star`)
     rather than offsetHeight: the panel is `display: none` until opened,
     and hidden elements always report offsetHeight 0. Crucially, stars
     inside the write-a-review CTA wrapper are IGNORED — that embedded
     widget always contains star elements (summary + review form) even for
     products with zero reviews, and counting them would keep the note
     hidden forever. Checks also re-run when a tab/accordion opens, since
     Judge.me may still be mid-render when the fixed timers fire. */
  /* The theme's CTA (data-forum-cta) renders a permanent "Add Post"
     button and "For more discussion Click Here" link, so the app's own
     versions of exactly those entry points are hidden to avoid doubles:
     its empty-state Start Discussion button, its Add Post button, and its
     Click Here line. Everything else the app renders (posts, Reply,
     votes, the inline post form) is left alone. The app ships no stable
     class names, so controls are matched by their visible labels. Runs on
     the same fixed one-shot timers as the review checks because the app
     renders asynchronously. */
  var FORUM_HIDE_LABELS = ['start discussion', 'add post'];

  /* Hiding just the button can leave behind an empty styled wrapper (the
     app wraps its CTAs in containers that pick up this section's button
     skinning), so climb to the outermost element whose entire text is the
     control's label and hide that instead. Never climbs past the panel. */
  function hideForumControl(control) {
    var label = (control.textContent || '').trim();
    var node = control;
    while (
      label !== '' &&
      node.parentElement &&
      !node.parentElement.classList.contains('product-tabs__panel--forum') &&
      node.parentElement.textContent.trim() === label
    ) {
      node = node.parentElement;
    }
    node.style.setProperty('display', 'none', 'important');
    /* Mark the app's CTA so the theme's Add Post button can proxy clicks
       to it, and remember what was hidden so the compose form can be
       revealed if the app renders it inside the hidden wrapper. */
    control.setAttribute('data-forum-app-cta', '');
    control.__forumHiddenNode = node;
  }

  function tidyForumPanel(panel) {
    panel.querySelectorAll('button, a, input[type="submit"], input[type="button"]').forEach(function (control) {
      if (control.closest('[data-forum-cta]')) return;
      var label = (control.value || control.textContent || '').trim().toLowerCase();
      if (FORUM_HIDE_LABELS.indexOf(label) !== -1) {
        hideForumControl(control);
        return;
      }
      if (label === 'click here') {
        /* "For more discussion Click Here" — the lead-in text is a sibling
           text node, so hide the wrapping element; fall back to the link
           alone if the parent holds more than that one line. */
        var wrap = control.parentElement;
        var target = wrap && wrap.textContent.trim().length < 80 ? wrap : control;
        target.style.setProperty('display', 'none', 'important');
      }
    });

    /* Flatten the app's white card around the compose form (see the CSS
       note): strip any painted background between the textarea and the
       panel. Detected via computed style because the app's wrapper
       classes aren't stable enough for CSS alone. Ancestors holding real
       post content (.post-body-content) are left alone — posts with a
       Reply option carry a hidden reply textarea inside their card, and
       stripping those cards made the posts unreadable. */
    panel.querySelectorAll('textarea').forEach(function (area) {
      var node = area.parentElement;
      while (node && node !== panel) {
        var bg = getComputedStyle(node).backgroundColor;
        if (
          bg !== 'transparent' &&
          bg !== 'rgba(0, 0, 0, 0)' &&
          !node.querySelector('.post-body-content')
        ) {
          node.style.setProperty('background', 'transparent', 'important');
          node.style.setProperty('border', 'none', 'important');
          node.style.setProperty('box-shadow', 'none', 'important');
        }
        node = node.parentElement;
      }
    });

    /* The app shows each author's full email address as their name; strip
       everything from the @ on so addresses aren't exposed publicly.
       Edits text nodes in place (idempotent — later timer passes find no
       @ and leave the name alone), and only inside .author-info-inner so
       @mentions in post bodies are untouched. */
    panel.querySelectorAll('.author-info-inner').forEach(function (author) {
      var walker = document.createTreeWalker(author, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var at = textNode.nodeValue.indexOf('@');
        if (at !== -1) textNode.nodeValue = textNode.nodeValue.slice(0, at);
      }
    });
  }

  function panelHasReviews(panel) {
    var stars = panel.querySelectorAll('.jdgm-star');
    for (var i = 0; i < stars.length; i++) {
      if (!stars[i].closest('.product-tabs__reviews-cta')) return true;
    }
    return false;
  }

  function checkPanel(panel) {
    var note = panel.querySelector('[data-app-panel-empty-note]');
    if (!note) return;
    note.hidden = panelHasReviews(panel);
  }

  function init() {
    var panels = document.querySelectorAll('[data-app-panel-check]');
    var forumPanels = document.querySelectorAll('.product-tabs__panel--forum');
    if (!panels.length && !forumPanels.length) return;

    [500, 1200, 2200, 3500, 5500, 8000].forEach(function (delay) {
      setTimeout(function () {
        panels.forEach(checkPanel);
        forumPanels.forEach(tidyForumPanel);
      }, delay);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tab-trigger]');
      if (!trigger) return;
      var target = document.getElementById(trigger.getAttribute('data-tab-target'));
      if (target && target.hasAttribute('data-app-panel-check')) {
        setTimeout(function () { checkPanel(target); }, 50);
      }
      if (target && target.classList.contains('product-tabs__panel--forum')) {
        setTimeout(function () { tidyForumPanel(target); }, 50);
      }
    });

    panels.forEach(function (panel) {
      var details = panel.closest('details');
      if (!details) return;
      details.addEventListener('toggle', function () {
        if (details.open) checkPanel(panel);
      });
    });

    forumPanels.forEach(function (panel) {
      var details = panel.closest('details');
      if (!details) return;
      details.addEventListener('toggle', function () {
        if (details.open) tidyForumPanel(panel);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-info-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toggle = document.getElementById('trust-bar-bulk-toggle');
  var panel = document.getElementById('trust-bar-bulk-panel');
  var closeButton = document.getElementById('trust-bar-bulk-close');

  if (!toggle || !panel) return;

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;

    if (open) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      setOpen(false);
      toggle.focus();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
